import React, { useState } from 'react';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';
import Sidebar from './Sidebar';
import Header from './Header';

export default function AppLayout({ title = 'CarbonRoute', children, contentClassName, headerActions }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-[100dvh] overflow-hidden bg-background text-foreground">
      {/* Desktop sidebar */}
      <div className="hidden md:flex flex-shrink-0">
        <Sidebar />
      </div>

      {/* Mobile sidebar (drawer: enters from the left and dismisses to the left) */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-64 p-0 border-r border-border bg-card">
          <Sidebar onItemClick={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Right side: header + main. min-w-0 lets wide children scroll inside their own box
          instead of widening the whole page (the cause of the horizontal overflow on phones). */}
      <div className="flex min-w-0 flex-1 flex-col">
        <Header title={title} onMenuClick={() => setMobileOpen(true)} actions={headerActions} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className={cn('mx-auto w-full max-w-[1400px]', contentClassName ?? 'px-4 py-6 sm:px-6 md:py-8 lg:px-8')}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
